const isApple = () =>
  typeof navigator !== "undefined" &&
  /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);

/** "⌘K" on a Mac, "Ctrl+K" everywhere else. */
export const askNoticeboardShortcutLabel = () =>
  isApple() ? "⌘K" : "Ctrl+K";

/** ⌘K or Ctrl+K, whichever the keyboard has. */
export const isAskNoticeboardShortcut = (e: KeyboardEvent) =>
  (e.metaKey || e.ctrlKey) && !e.altKey && e.key.toLowerCase() === "k";
